import { render, staticRenderFns } from "./GameSettingsSummary.vue?vue&type=template&id=0dc377b6&scoped=true&"
import script from "./GameSettingsSummary.vue?vue&type=script&lang=js&"
export * from "./GameSettingsSummary.vue?vue&type=script&lang=js&"
import style0 from "./GameSettingsSummary.vue?vue&type=style&index=0&id=0dc377b6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc377b6",
  null
  
)

export default component.exports